// WebSocket configuration for Soketi using Pusher JS directly
// Soketi is compatible with Pusher protocol, so we use Pusher JS client
import Pusher from 'pusher-js';

console.log('%c[WebSocket] 📦 Loading WebSocket configuration...', 'color: #2196F3; font-weight: bold');

// Soketi configuration from environment variables
const SOKETI_HOST = process.env.REACT_APP_SOKETI_HOST || 'socket.bettercoffee.my.id';
const SOKETI_PORT = process.env.REACT_APP_SOKETI_PORT || '443';
const SOKETI_SCHEME = process.env.REACT_APP_SOKETI_SCHEME || 'https';
const SOKETI_APP_ID = process.env.REACT_APP_SOKETI_APP_ID || 'app-id';
const SOKETI_APP_KEY = process.env.REACT_APP_SOKETI_APP_KEY || 'app-key';
const SOKETI_APP_SECRET = process.env.REACT_APP_SOKETI_APP_SECRET || 'app-secret';

// Log environment variables (mask sensitive data)
console.log('[WebSocket] 🔧 Environment Variables:', {
  REACT_APP_SOKETI_HOST: SOKETI_HOST,
  REACT_APP_SOKETI_PORT: SOKETI_PORT,
  REACT_APP_SOKETI_SCHEME: SOKETI_SCHEME,
  REACT_APP_SOKETI_APP_ID: SOKETI_APP_ID.substring(0, 10) + '...',
  REACT_APP_SOKETI_APP_KEY: SOKETI_APP_KEY.substring(0, 10) + '...',
  REACT_APP_SOKETI_APP_SECRET: SOKETI_APP_SECRET.substring(0, 10) + '...',
  'process.env values': {
    REACT_APP_SOKETI_HOST: process.env.REACT_APP_SOKETI_HOST,
    REACT_APP_SOKETI_PORT: process.env.REACT_APP_SOKETI_PORT,
    REACT_APP_SOKETI_SCHEME: process.env.REACT_APP_SOKETI_SCHEME,
  },
});

// WebSocket URL
const WS_URL = process.env.REACT_APP_WEBSOCKET_URL || `${SOKETI_SCHEME}://${SOKETI_HOST}:${SOKETI_PORT}`;

// Initialize Pusher client for Soketi
// Soketi uses Pusher protocol, so Pusher JS works directly
const pusherConfig = {
  wsHost: SOKETI_HOST,
  wsPort: parseInt(SOKETI_PORT),
  wssPort: parseInt(SOKETI_PORT),
  forceTLS: SOKETI_SCHEME === 'https',
  enabledTransports: ['ws', 'wss'],
  cluster: '', // Empty cluster for Soketi
  disableStats: true,
  // For private/presence channels, uncomment and configure auth endpoint:
  // authEndpoint: `${WS_URL}/api/broadcasting/auth`,
  // auth: {
  //   headers: {
  //     'X-Soketi-App-Id': SOKETI_APP_ID,
  //     'X-Soketi-App-Key': SOKETI_APP_KEY,
  //     'X-Soketi-App-Secret': SOKETI_APP_SECRET,
  //   },
  // },
};

console.log('[WebSocket] 🔧 Soketi Configuration:', {
  host: SOKETI_HOST,
  port: SOKETI_PORT,
  scheme: SOKETI_SCHEME,
  appKey: SOKETI_APP_KEY.substring(0, 10) + '...',
  wsUrl: WS_URL,
  config: pusherConfig,
});

const pusherClient = new Pusher(SOKETI_APP_KEY, pusherConfig);

console.log('[WebSocket] ✅ Pusher client initialized for Soketi');

// Add connection event listeners immediately
pusherClient.connection.bind('state_change', (states) => {
  console.log('%c[WebSocket] 🔄 Connection state changed:', 'color: #9C27B0; font-weight: bold', {
    previous: states.previous,
    current: states.current,
    timestamp: new Date().toISOString(),
  });
});

pusherClient.connection.bind('connected', () => {
  console.log('%c[WebSocket] ✅ Connected to Soketi server', 'color: #4CAF50; font-weight: bold', {
    socketId: pusherClient.connection.socket_id,
    timestamp: new Date().toISOString(),
  });
});

pusherClient.connection.bind('disconnected', () => {
  console.log('%c[WebSocket] ⚠️ Disconnected from Soketi server', 'color: #FF9800; font-weight: bold', {
    timestamp: new Date().toISOString(),
  });
});

pusherClient.connection.bind('error', (error) => {
  console.error('%c[WebSocket] ❌ Connection error:', 'color: #F44336; font-weight: bold', {
    error,
    errorType: error?.type,
    errorMessage: error?.error,
    timestamp: new Date().toISOString(),
  });
});

// Log initial connection state
console.log('[WebSocket] 📊 Initial connection state:', pusherClient.connection.state);

export default pusherClient;
export { WS_URL, SOKETI_HOST, SOKETI_PORT, SOKETI_SCHEME };
